import type { FeedbackCategory } from "../../data/feedbackData";

type Cat = FeedbackCategory;

export const PILLAR_FEEDBACKS_FR: Record<number, Record<Cat, string>> = {
  1: {
    bas: "Votre stratégie marketing navigue à vue, ce qui a le mérite de l'aventure, mais rarement du ROI. Voyons si votre marque a pris les devants.",
    mid: "Les bases stratégiques sont là, avec quelques zones grises. Voyons si votre marque s'appuie dessus, ou fonctionne en parallèle.",
    haut: "Votre stratégie est plus structurée que celle de la plupart des entreprises B2B. La pression est maintenant sur l'exécution : votre marque suit-elle ?",
  },
  2: {
    bas: "Votre marque et vos outils ne font pas encore le travail à votre place. Chaque interaction client demande plus d'effort qu'elle ne devrait.",
    mid: "Votre marque a des fondations, sans être encore un levier de croissance. Le potentiel est là, la cohérence manque.",
    haut: "Votre marque est un actif. Identité cohérente, outils en place, chaque action marketing porte plus loin.",
  },
  3: {
    bas: "Côté contenu et visibilité, c'est le calme plat. Vos concurrents captent l'attention que vous ne disputez pas.",
    mid: "Du contenu et de la visibilité, mais pas encore le rythme ou la précision qui transforment l'attention en pipeline.",
    haut: "Votre machine à contenu tourne. Production régulière, distribution active, présence coordonnée, c'est un moteur.",
  },
  4: {
    bas: "Côté IA et outils, vous partez de loin. Mais c'est aussi le pilier qui progresse le plus vite quand on s'y met vraiment.",
    mid: "Quelques outils, quelques usages IA, mais pas encore de système. Vous avez compris l'enjeu, il reste à structurer.",
    haut: "Votre stack est en place et l'IA travaille pour vous. C'est un levier de compétitivité que peu d'équipes B2B maîtrisent encore.",
  },
};

export const CROSS_P2_FR: Record<Cat, Record<Cat, string>> = {
  bas: {
    bas: "Ni la stratégie ni la marque ne portent votre marketing, il avance à la force des bras. C'est courant en B2B, et c'est le terrain où les gains rapides sont les plus visibles.",
    mid: "Votre marque a une longueur d'avance sur votre stratégie. Les fondations existent, il manque le plan de vol pour les exploiter.",
    haut: "Votre marque est nettement plus mature que votre stratégie. Belle vitrine, mais sans plan de circulation, les visiteurs admirent, sans forcément passer à l'action.",
  },
  mid: {
    bas: "Votre stratégie est en avance sur votre marque. Vous savez où aller mais votre image et vos outils ne suivent pas encore le mouvement.",
    mid: "Stratégie et marque avancent au même rythme, de façon équilibrée. C'est stable, voyons si votre contenu crée la différence.",
    haut: "Votre marque est plus forte que votre stratégie. Les moyens d'exécuter sont là, il reste à affiner la direction pour les exploiter pleinement.",
  },
  haut: {
    bas: "Contraste net : la stratégie est solide, la marque ne suit pas. C'est comme un excellent produit dans un emballage qui ne lui rend pas justice.",
    mid: "La stratégie mène, la marque suit. L'écart n'est pas dramatique : quelques réglages sur l'image et les outils peuvent débloquer beaucoup.",
    haut: "Stratégie et marque sont alignées : combinaison rare en B2B. La pression est maintenant sur votre contenu et votre visibilité.",
  },
};

export const CROSS_P3_UNIFORME_FR: Record<Cat, string> = {
  bas: "Trois piliers, même constat : le marketing est en chantier. Paradoxalement, c'est un bon point de départ : pas de déséquilibre à corriger, juste un socle à construire. Dernier thème à venir.",
  mid: "Trois piliers au même niveau intermédiaire. Pas de trou béant, pas de force distinctive. Votre marketing fonctionne, il ne se distingue pas encore. Dernier thème à venir.",
  haut: "Stratégie, marque et contenu : tous au-dessus de la moyenne B2B. C'est rare. Voyons si vos outils et votre usage de l'IA complètent l'édifice.",
};

export const CROSS_P3_EN_RETRAIT_FR: Record<
  "strategie" | "marque" | "contenu",
  string
> = {
  strategie:
    "L'exécution (marque, contenu) est en avance sur la stratégie. Pattern fréquent : on fait d'abord, on structure ensuite. Le risque, c'est beaucoup d'activité sans convergence.",
  marque:
    "Stratégie et contenu avancent, mais l'infrastructure (marque, outils, site) ne suit pas. Goulot d'étranglement classique en B2B : tout semble fonctionner, rien ne scale.",
  contenu:
    "Stratégie et marque tiennent la route, mais la visibilité ne suit pas. Votre marketing existe en interne mais il est quasi invisible de l'extérieur. Bonne nouvelle : c'est le pilier qui progresse le plus vite.",
};

export const CROSS_P3_EN_AVANCE_FR: Record<
  "strategie" | "marque" | "contenu",
  string
> = {
  strategie:
    "La stratégie est votre point fort, l'exécution court derrière. Vision claire, moyens limités ou mal alignés. Le dernier thème dira si les outils peuvent combler l'écart.",
  marque:
    "Votre infrastructure (marque, outils, site) est en avance sur le reste. Les fondations sont solides, il manque la direction stratégique ou le contenu pour les exploiter.",
  contenu:
    "Votre contenu mène la danse, mais ni la stratégie ni l'infrastructure ne sont au même niveau. Être visible, c'est bien, encore faut-il que l'attention se convertisse.",
};
